import React, { useContext } from 'react'
import { CookieContext } from 'src/context/cookie/cookie.context'
import { CookieBanner } from './cookie-banner'

export const CookieBannerWrapper: React.FC = () => {
  const { showCookieBanner, acceptCookies } = useContext(CookieContext)

  if (!showCookieBanner) {
    return null
  }

  return <CookieBanner onAccept={acceptCookies} />
}
